import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  GetSuspectedManipulationCountUseCaseInterface,
  GetSuspectedManipulationUseCaseInterface,
  GetSuspectedStudentsRankingUseCaseInterface,
} from 'domain/usecases';

interface ISuspectedManipulationLocationState {
  suspectedManipulation: GetSuspectedManipulationUseCaseInterface.Result['data'];
  suspectedStudentsRanking: GetSuspectedStudentsRankingUseCaseInterface.Result['data'];
  suspectedManipulationCount: GetSuspectedManipulationCountUseCaseInterface.Result;
  suspectedManipulationTotal: number;
  suspectedStudentsRankingTotal: number;
}

const initialState: ISuspectedManipulationLocationState = {
  suspectedManipulation: [],
  suspectedStudentsRanking: [],
  suspectedManipulationCount: null,
  suspectedManipulationTotal: 0,
  suspectedStudentsRankingTotal: 0,
};

export const SuspectedManipulationLocationSlice = createSlice({
  name: 'suspected-manipulation-location',
  initialState,
  reducers: {
    saveSuspectedManipulationLocation: (
      state,
      action: PayloadAction<{
        data: GetSuspectedManipulationUseCaseInterface.Result['data'];
        total: number;
      }>,
    ) => {
      state.suspectedManipulation = action.payload.data;
      state.suspectedManipulationTotal = action.payload.total;
    },
    saveSuspectedStudentsRanking: (
      state,
      action: PayloadAction<{
        data: GetSuspectedStudentsRankingUseCaseInterface.Result['data'];
        total: number;
      }>,
    ) => {
      state.suspectedStudentsRanking = action.payload.data;
      state.suspectedStudentsRankingTotal = action.payload.total;
    },
    saveSuspectedManipulationCount: (
      state,
      action: PayloadAction<GetSuspectedManipulationCountUseCaseInterface.Result>,
    ) => {
      state.suspectedManipulationCount = action.payload;
    },
    clearSuspectedManipulationLocation: (state) => {
      state.suspectedManipulation = [];
      state.suspectedManipulationTotal = 0;
    },
    clearSuspectedStudentsRanking: (state) => {
      state.suspectedStudentsRanking = [];
      state.suspectedStudentsRankingTotal = 0;
    },
    clearSuspectedManipulationCount: (state) => {
      state.suspectedManipulationCount = null;
    },
  },
});

export const {
  saveSuspectedManipulationLocation,
  clearSuspectedManipulationLocation,
  saveSuspectedStudentsRanking,
  clearSuspectedStudentsRanking,
  saveSuspectedManipulationCount,
  clearSuspectedManipulationCount,
} = SuspectedManipulationLocationSlice.actions;

export default SuspectedManipulationLocationSlice.reducer;
